//Component is created by nisha, a modal of add edit shipment with responsiveness

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LocationAutoComplete from "./LocationAutoComplete";
import { useSpin } from "../../components/SpinContext";
import { useToken } from "../../common/helper";

// Components
import { Flex, Modal, Form, Row, Col, message, AutoComplete } from "antd";
import {
  CustomButton,
  CustomTitle,
  CustomDynamicSelect,
  CustomInput,
} from "../../components";
import { CreateNewShipment, GetSingleShipment } from "../../api's/shipment";
import {
  getCouriersDDL,
  getSensorsDDL,
  getProductDDL,
  getLocationDDL,
  getCompanyCouriersDDL,
} from "../../common/utils/dropDown";
import { useSelector } from "react-redux";
import { GetCompanySensors } from "../../api's/settings";

const CreateShipmentModal = ({
  modalOpen,
  setModalOpen,
  onShipmentSuccess,
  shipmentId,
}) => {
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [locationList, setLocationList] = useState([]);
  const [fromLocation, setFromLocation] = useState(null);
  const [toLocation, setToLocation] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);
  const [couriersList, setCouriersList] = useState([]);
  const [sensorsList, setSensorsList] = useState([]);
  const [productList, setProductList] = useState([]);
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const [form] = Form.useForm();
  // Form submission handler

  const handleAddressPlaceSelect = (place, fieldName) => {
    if (fieldName === "from_location") {
      setFromLocation(place);
    } else if (fieldName === "to_location") {
      setToLocation(place);
    }
    form.setFieldsValue({
      [fieldName]: place.name,
    });
  };

  //get single shipment by shipment id
  useEffect(() => {
    if (shipmentId) {
      //  GetSingleShipmentById(shipmentId)
    }
  }, [shipmentId]);

  const GetSingleShipmentById = (id) => {
    showSpin();
    GetSingleShipment(token, id)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              form.setFieldsValue({
                courier: resp?.courier?.id || null,
                courier_tracking_id: resp?.courier_tracking_id || null,
                sensor: resp?.sensor?.id || null,
                sensor_tracking_id: resp?.sensor_tracking_id || null,
                reference_number: resp?.reference_number || null,
                id: resp?.id || null,
                product: resp?.product?.id || null,
                from_location: resp?.from_location?.id || null,
                to_location: resp?.to_location?.id || null,
              });
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  //Making dropdwon Calls for transport providers

  useEffect(() => {
    getCompanyCouriersDDL(token).then((val) => {
      if (val && val.length > 0) {
        setCouriersList(val);
      }
    });
  }, []);

  useEffect(() => {
    GetCompanySensors(token).then((res) => {
      const data = res?.data || null;
      if (data) {
        if (data.data?.is_success) {
          if (data.data.data && data.data.data.length > 0) {
            setSensorsList(data.data.data);
          }
        } else {
          message.error(data?.data?.message);
        }
      }
    });
  }, []);

  useEffect(() => {
    getProductDDL(token).then((val) => {
      if (val && val.length > 0) {
        setProductList(val);
      }
    });
  }, []);

  useEffect(() => {
    getLocationDDL(token).then((val) => {
      if (val && val.length > 0) {
        setLocationList(val);
      }
    });
  }, []);

  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      let model = { ...values };
      model.id = null;
      if (fromLocation) {
        if (fromLocation.id && fromLocation.id !== undefined) {
            model.from_location = fromLocation.id;
        } else {
            model.from_address = fromLocation.name; 
            delete model.from_location; 
        }
    }
    
    if (toLocation) {
        if (toLocation.id && toLocation.id !== undefined) {
            model.to_location = toLocation.id; 
        } else {
            model.to_address = toLocation.name; 
            delete model.to_location; 
        }
    }
  
      console.log("Final model sent to API:", model);

      if (!model.sensor && !model.courier) {
        message.error(
          "At least one of sensor or transport provider must be filled"
        );
        return;
      }

      submitShipment(model);
    }
  };

  const onFormValueCahnges = () => {
    if (
      !form.getFieldValue("sensor_tracking_id") &&
      !form.getFieldValue("sensor")
    ) {
      form.setFields([{ name: "sensor_tracking_id", errors: [] }]);
      form.setFields([{ name: "sensor", errors: [] }]);
    }
    if (
      !form.getFieldValue("courier_tracking_id") &&
      !form.getFieldValue("courier")
    ) {
      form.setFields([{ name: "courier_tracking_id", errors: [] }]);
      form.setFields([{ name: "courier", errors: [] }]);
    }
  };

  const handleCancel = () => {
    setModalOpen(false);
  };
  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const submitShipment = (model) => {
    setIsFormValid(true);
    showSpin();
    CreateNewShipment(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            message.success(data?.data?.message);
            onShipmentSuccess();
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  return (
    <Modal
      title=""
      centered
      open={modalOpen}
      onCancel={() => setModalOpen(false)}
      width={590}
      styles={{
        content: {
          borderRadius: "18px", // Styles for the entire modal content
          overflow: "hidden", // Prevents content from spilling over
        },
      }}
      footer={[
        <React.Fragment key="footer-actions">
          <Flex gap="16px" justify="end">
            <CustomButton
              key="button1"
              onClick={handleCancel}
              text={"Cancel"}
              bgColor="transparent"
              color="black"
              fontSize="16px"
              fontWeight="500"
              boxShadow="none"
              height="48px"
            />
            <CustomButton
              key="button2"
              text={"Add shipment"}
              bgColor="black"
              color="white"
              height="auto"
              width="auto"
              fontSize="16px"
              fontWeight="500"
              boxShadow="none"
              borderRadius="8px"
              isFormValid={isFormValid}
              onClick={() => {
                form.submit();
              }}
            />
          </Flex>
        </React.Fragment>,
      ]}
    >
      <div></div>
      <CustomTitle
        text={"Track a new shipment"}
        fontSize="28px"
        lineHeight="36px"
        fontWeight="700"
        marginBottom="0px"
      />
      <main
        style={{
          marginBottom: "20px",
          marginTop: "20px",
          marginRight: "-3px",
          marginLeft: "-5px",
        }}
      >
        <Form
          form={form}
          name="CreateNewShipment"
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          onValuesChange={onFormValueCahnges}
        >
          <Row gutter={[0, 16]}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="custom-input"
                label="Transport provider"
                name="courier"
                style={{ margin: "6px" }}
                rules={[
                  ({ getFieldValue }) => ({
                    validator: (_, value) => {
                      if (getFieldValue("courier_tracking_id") && !value) {
                        return Promise.reject(
                          new Error("Please select transport provider")
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <CustomDynamicSelect
                  placeholder="Select"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  options={couriersList}
                  label="courier_name"
                  isCourier={true}
                  allowClear={true}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="custom-input"
                label="Transport provider tracking ID"
                name="courier_tracking_id"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value && value.trim() === "") {
                        return Promise.reject(
                          new Error("Only spaces are not allowed")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                  ({ getFieldValue }) => ({
                    validator: (_, value) => {
                      if (getFieldValue("courier") && !value) {
                        return Promise.reject(
                          new Error(
                            "Please enter transport provider tracking ID"
                          )
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                style={{ margin: "6px" }}
              >
                <CustomInput
                  placeholder="Paste tracking number"
                  height="36px"
                  width="100%"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="custom-input"
                label="Sensor"
                name="sensor"
                style={{ margin: "6px" }}
                rules={[
                  ({ getFieldValue }) => ({
                    validator: (_, value) => {
                      if (getFieldValue("sensor_tracking_id") && !value) {
                        return Promise.reject(
                          new Error("Please select sensor")
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <CustomDynamicSelect
                  placeholder="Select"
                  width="100%"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  allowClear={true}
                  isSensor={true}
                  options={sensorsList}
                  label="sensor_name"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="custom-input"
                label="Sensor ID"
                name="sensor_tracking_id"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value && value.trim() === "") {
                        return Promise.reject(
                          new Error("Only spaces are not allowed")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                  ({ getFieldValue }) => ({
                    validator: (_, value) => {
                      if (getFieldValue("sensor") && !value) {
                        return Promise.reject(
                          new Error("Please enter sensor tracking ID")
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                style={{ margin: "6px" }}
              >
                <CustomInput
                  placeholder="Paste tracking number"
                  height="36px"
                  width="100%"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="custom-input"
                label="Reference number"
                name="reference_number"
                rules={[
                  { required: true, message: "Please enter reference number" },
                  {
                    validator: (_, value) => {
                      // Check if the value is only spaces or empty
                      if (value && value.trim() === "") {
                        return Promise.reject(
                          new Error("Only spaces are not allowed")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                style={{ margin: "6px" }}
              >
                <CustomInput
                  placeholder="Your internal reference #"
                  height="36px"
                  width="100%"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                className="custom-input"
                label="Product"
                name="product"
                rules={[{ required: true, message: "Please select product" }]}
                style={{ margin: "6px" }}
              >
                <CustomDynamicSelect
                  placeholder="Select"
                  width="100%"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  options={productList}
                  allowClear={true}
                />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={24} md={12} lg={12}> */}
            {/* <Form.Item
                className="custom-input"
                label="From Location"
                name="from_location"
                rules={[
                 // { required: true, message: "Please select origin" },
                  // ({ getFieldValue }) => ({
                  //     validator: (_, value) => {
                  //         if (getFieldValue('to_location') && !value) {
                  //             return Promise.reject(new Error('Please select origin'));
                  //         }
                  //         return Promise.resolve();
                  //     },
                  // }),
                ]}
                style={{ margin: "6px" }}
              >
                <CustomDynamicSelect
                  placeholder="Select"
                  width="100%"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  options={locationList}
                  allowClear={true}
                />
              </Form.Item> */}
            {/* </Col> */}
            {/* <Form.Item
                className="custom-input"
                label="To Location"
                name="to_location"
                rules={[
                 // { required: true, message: "Please select destination" },
                  // ({ getFieldValue }) => ({
                  //     validator: (_, value) => {
                  //         if (getFieldValue('from_location') && !value) {
                  //             return Promise.reject(new Error('Please select destination'));
                  //         }
                  //         return Promise.resolve();
                  //     },
                  // }),
                ]}
                style={{ margin: "6px" }}
              >
                <CustomDynamicSelect
                  placeholder="Select"
                  width="100%"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  options={locationList}
                  allowClear={true}
                />
              </Form.Item> */}

            <Col xs={24} sm={24} md={12} lg={12}>
              <LocationAutoComplete
                form={form}
                locationList={locationList}
                handleAddressPlaceSelect={(place) =>
                  handleAddressPlaceSelect(place, "from_location")
                }
                fieldName="from_location"
                label="From Location"
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <LocationAutoComplete
                form={form}
                locationList={locationList}
                handleAddressPlaceSelect={(place) =>
                  handleAddressPlaceSelect(place, "to_location")
                }
                fieldName="to_location"
                label="To Location"
              />
            </Col>
          </Row>
        </Form>
      </main>
    </Modal>
  );
};

export default CreateShipmentModal;
